module.exports = __webpack_public_path__ + "static/media/targetMarker.98c35d73.svg";